import ActionTickWithGradient from './ActionTickWithGradient';

export default ActionTickWithGradient;
